<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl [dato]="dato" titulo="Revalidación / Regularización" url="revalidacion"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div *ngIf="ctrl.cargando || ctrl.cargarDatosCatalogo || cargando" align="center" id="banner">
    <div class="bloquear-azul"></div>
    <span class="tag is-primary is-large " style="position: absolute; top: 45%; font-size: 2em; z-index: 999999999;  left: 45%;">
        <span class="icon">
            <i class="icon-worldwide fa-spin"></i>
        </span> &nbsp;
    <span>Cargando...</span>
    </span>
</div>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; height:100%;">

            <!-- formulario -->
            <form (ngSubmit)="ctrl.enviar()" name="form" novalidate>
                <section class="hero is-primary">
                    <div class="hero-body">
                        <a (click)="ctrl.cargarCatalogo('logos64', 'logos64?carreras_planes_id='+alumnos.carrera_plan.id, 'logo64');" id="catalogos"></a>
                        <a (click)="asignarLogos(ctrl.logos64); " id="logo64"></a>
                        <!-- Opciones  -->
                        <section class="hero is-primary">
                            <div class="hero-head">
                                <nav class="level">
                                    <!-- Left side -->
                                    <div class="level-left">
                                        <div class="level-item">
                                            <p class="title">
                                                <span *ngIf="!ctrl.cargando" class="icon is-medium">
                                                    <i class="icon-insurance"></i>
                                                </span>
                                                <span *ngIf="ctrl.cargando  || cargando" class="icon is-medium">
                                                    <i class="icon-worldwide fa-spin"></i>
                                                </span>
                                                <span class="icon is-medium">
                                                    <i class="icon-file"></i>
                                                </span> Revalidación
                                            </p>
                                        </div>

                                    </div>

                                    <!-- Right side -->
                                    <div class="level-right">

                                        <a (click)="ctrl.regresar()" class="navbar-item is-primary tooltip">
                                            <span class="icon fa-2x">
                                                <i class="icon-back"></i>
                                            </span>
                                            <span class="tooltiptext">Regresar</span>
                                        </a>

                                        <a (click)="cargarDatos(alumnos.id)" *ngIf="alumnos.id != ''" class="navbar-item is-primary tooltip" id='cargar_datos_actualizar'>
                                            <span class="icon fa-2x">
                                                <i class="icon-worldwide"></i>
                                            </span>
                                            <span class="tooltiptext">Actualizar</span>
                                        </a>

                                        <button (click)="ctrl.abrirModal('confirmarCalificacion')" *ngIf="!tieneid" [disabled]="cargando" [ngClass]="{'is-loading': cargando}" class="navbar-item  tooltip" type="button">
                                            <span class="icon fa-2x has-text-success">
                                                <i class="icon-diskette"></i>
                                            </span>
                                            <span class="tooltiptext">Guardar</span>
                                        </button>
                                    </div>
                                </nav>
                            </div>
                        </section>
                    </div>
                </section>

                <section class="section" style="overflow-y:auto; overflow-x:hidden; padding: 1rem; height: 86vh;">
                    <section class="hero is-primary">
                        <div class="hero-body">
                            <nav class="level ">
                                <!-- Left side -->
                                <div class="level-left ">
                                    <div class="level-item">
                                        <p class="title">
                                            <span *ngIf="!ctrl.cargando || !cargando" class="icon is-medium">
                                                <i class="icon-edit-1"></i>
                                            </span> Buscar alumnos
                                        </p>
                                    </div>
                                </div>
                                <div class="level-right " style=" width: 78%; ">
                                    <div class="level-item" style=" width: 100%; ">
                                        <div class="control has-icons-left is-expanded" style=" width: 100%; ">
                                            <input (valueChanged)="select_articulo_autocomplete($event)" [list-formatter]="autocompleListFormatter" [close-on-focusout]="false" [source]="observableSource.bind(this)" autocomplete="off" autofocus class="input is-success is-medium" display-property-name="id" id='buscarArticulo' loading-text="Cargando..."
                                                min-chars="3" ngui-auto-complete no-match-found-text="No hay resultados." path-to-data="" placeholder="Escribe el nombre del alumno, o la matrícula" type="text" value-property-name="id">
                                            <span class="icon is-medium is-left">
                                                <i class="icon-search3"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </section>
                    <div *ngIf="cargando" class="is-fullwidth has-text-centered">
                        <br>
                        <span class="tag is-primary is-large ">
                            <span class="icon">
                                <i class="icon-worldwide fa-spin"></i>
                            </span> &nbsp;
                        <span>Cargando...</span>
                        </span>
                    </div>

                    <section style="padding: .1rem !important; overflow:auto;">

                        <div *ngIf="alumnos.alumnos_metadatos.nombre != ''" class="box">
                            <article class="media">
                                <div class="media-left">
                                    <figure class="image is-64x64">
                                        <img [src]="alumnos.alumnos_metadatos.foto != null ? ctrl.API_PATH+'/adjunto/alumnos/'+alumnos.alumnos_metadatos.foto : alumnos.alumnos_metadatos.avatar != null ? alumnos.alumnos_metadatos.avatar : './assets/128x128.png'" alt="Image">
                                    </figure>
                                </div>
                                <div class="media-content" style="padding: 1.2em;">
                                    <div class="content">
                                        <p>
                                            <strong>
                                                {{alumnos.alumnos_metadatos.nombre }}
                                                {{alumnos.alumnos_metadatos.apellido_paterno }}
                                                {{alumnos.alumnos_metadatos.apellido_materno }}
                                            </strong>
                                            <small>{{alumnos.alumnos_metadatos.email}}</small>
                                            <span>
                                                Grupo:
                                                {{alumnos.grupos.clave}}</span>
                                            <span>
                                                Nivel:
                                                {{alumnos.grupos.nivel}}
                                                {{alumnos.grupos.identificador}}</span>
                                            <span>
                                                Beca:
                                                {{alumnos.becas ? alumnos.becas.becas.nombre : 'Sin beca'}}</span>
                                            <br>
                                            <strong>
                                                Carrera Plan:</strong> {{alumnos.carrera_plan.nombre}}
                                            <strong>
                                                Carrera:</strong> {{alumnos.carreras.nombre}}
                                            <br>
                                            <strong>
                                                Modalidad:</strong> {{alumnos.modalidades.nombre}}


                                            <!-- <button (click)="imprimirKardex(dato)" *ngIf="dato[0]" class="navbar-item " style="float: right;" type="button">
                                                                                            <span class="icon fa-2x has-text-black"></span>
                                                                                            <span [ngClass]="(dato[0][0] * 1) > carrera_plan.minimo_aprobatorio ? 'has-text-success' : 'has-text-danger'" style="font-weight: 900">PROMEDIO GENERAL:
                                                                                                {{dato[0][0]}}</span>
                                                                                        </button>
                                            
                                                                                        <button (click)="imprimirKardex(dato)" class="navbar-item  tooltip" style="float: right;" type="button">
                                                                                            <span class="icon fa-2x has-text-black">
                                                                                                <i class="icon-printer"></i>
                                                                                            </span>
                                                                                            <span class="tooltiptext">Imprimir Kardex</span>
                                                                                        </button> -->
                                        </p>

                                    </div>
                                </div>
                            </article>
                        </div>
                        <div *ngFor="let item of dato | keys">
                            <div *ngIf="item.key > 0">
                                <div [style.background]="item.key%2 == 0 ? 'rgba(220, 220, 220, 0.28)' : '#ffffff'" class="box">
                                    <article class="media">
                                        <div class="media-left" style="display: table-caption; vertical-align: middle;">
                                            <p style="font-size:1.5em">
                                                <strong>{{periodos_escolares.tipos_periodos.nombre_para_mostrar}}:
                                                    {{item.key}}</strong>
                                            </p>
                                        </div>
                                        <div class="media-content">
                                            <div *ngFor="let materia of item.value; let mati = index" class="card">
                                                <header class="card-header">
                                                    <div class="card-header-title" style="font-weight: 200; display: flow-root;">
                                                        <div *ngIf="materia.es_practica == 0" style="float:left">
                                                            <strong>
                                                            ({{materia.clave}}) {{materia.nombre}} </strong>
                                                            <small *ngIf="materia.tiene_practica" class="tag">Tiene practica</small>
                                                        </div>
                                                        <div class="tile is-ancestor" style="float: right;" *ngIf="materia.es_practica == 0">

                                                            <div class="tile is-parent">
                                                                <!-- <article class="tile is-child box"> -->
                                                                <div class="field">
                                                                    <!-- <label class="label">Promedio:</label> -->
                                                                    <div class="control is-expanded  has-icon has-icon-left">
                                                                        <input placeholder="0" [(ngModel)]="materia.promedio" [max]="carrera_modulo_nivel[item.key].maximo_aprobatorio" [ngModelOptions]="{standalone: true}" [step]="carrera_modulo_nivel[item.key].materia_numero_decimales" class="input" min="0" type="number">
                                                                    </div>
                                                                </div>

                                                                <div class="field">
                                                                    <div class="b-checkbox is-info">
                                                                        <!-- <input class="styled" [(ngModel)]="materia.validar" [ngModelOptions]="{standalone: true}" checked type="checkbox"> -->
                                                                        <!-- <input id="validar{{mati}}" name="validar{{mati}}" class="styled" type="checkbox" [(ngModel)]="materia.validar" [ngModelOptions]="{standalone: true}" [checked]="materia.get('validar').value == 1 ? true : false">
                                                                        <label for="validar">
                                                                            Validar
                                                                        </label> -->
                                                                    </div>
                                                                </div>
                                                                <!-- </article> -->
                                                            </div>

                                                        </div>
                                                        <!-- <div style="float:left" *ngIf="materia.es_practica == 1"> <strong>PRACTICA: </strong>{{materia.nombre}} ({{ materia.porcentaje_valor }})</div>
                                                                                                                                                                        <div style="float:right" *ngIf="materia.es_practica == 0" [ngClass]="(materia.promedio * 1) > carrera_modulo_nivel[item.key].minimo_aprobatorio ? 'has-text-success' : 'has-text-danger' "> <span style="font-weight: 900">PROMEDIO: </span>{{materia.promedio}}</div> -->
                                                    </div>
                                                </header>
                                            </div>
                                        </div>
                                    </article>
                                </div>
                            </div>
                        </div>

                    </section>
                </section>
            </form>
        </div>
    </div>
</div>


<div class="modal" id="confirmarCalificacion">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">
                <i class="fa fa-warning"></i> Alerta
            </p>
            <button (click)="ctrl.cancelarModal('confirmarCalificacion')" class="delete"></button>
        </header>
        <section class="modal-card-body">
            <div class="content">
                <h1>¿Esta seguro de guardar los cambios?</h1>
                <p>Esta acción podra afectar boletas impresas anteriormente</p>
            </div>
        </section>
        <footer class="modal-card-foot">
            <a (click)="enviar()" [ngClass]="{'is-loading': borrarCargando}" class="button is-success">Continuar</a>
            <a (click)="ctrl.cancelarModal('confirmarCalificacion')" class="button">Cerrar</a>
        </footer>
    </div>
</div>